import { EditableClientProps } from '@/shared/types/editable';

import { addKeydownListener } from '@/front/editable/utils';

export const input = (props: EditableClientProps, element: HTMLElement) => {
  const p = { ...props };

  const messageDivId = `${element.id}-msg`;

  const input = document.createElement(p.type === 'RTE' ? 'textarea' : 'input');

  input.name = p.field;

  if (p.type !== 'RTE') {
    addKeydownListener(input);
  }

  input.dataset.msgContainerid = messageDivId;

  input.autocomplete = 'off';

  element.appendChild(input);

  const messageDiv = document.createElement('div');

  messageDiv.id = messageDivId;

  element.appendChild(messageDiv);

  return input;
};
